import CuratenieFabriciDepoziteHale from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale";

export default function CuratenieFabriciDepoziteHalePage() {
    return <CuratenieFabriciDepoziteHale />;
}
